import { Title, Link, MaskCpf } from "@funcional/react-ui";
import { IntlEnum } from "@funcional/react-intl-ui";
import { useProgramBeneficiaries } from "@pbm/beneficiaries/hooks";
import { IProgramBeneficiary } from "@pbm/beneficiaries/contracts";
import { useMemo } from "react";
import { Column } from "react-table";
import { FormattedDate } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import { GridView } from "@funcional/react-table-ui";

interface CellProps {
  value: any;
  row: { original: IProgramBeneficiary };
}

export default function ListProgramBeneficiaryPage() {
  const history = useHistory();
  const { id }: { id: string } = useParams();

  const showRecord = (row: any) =>
    history.push(
      `/pbm/programs/${row.original.program?.code || "-"}/beneficiaries/${
        row.original?.beneficiary?.id
      }`
    );

  const columns: Column<IProgramBeneficiary>[] = useMemo(
    () => [
      {
        Header: "Programa",
        accessor: (row) => row.program?.code,
        Cell: ({ row: { original } }: CellProps) => (
          <Link to={`/pbm/programs/${original.program?.code}`}>
            {original.program?.name}
          </Link>
        ),
      },
      {
        Header: "CPF",
        accessor: "id",
        Cell: ({ row: { original } }: CellProps) => (
          <Link
            to={`/pbm/programs/${original.program?.code || "-"}/beneficiaries/${
              original.beneficiary?.id
            }`}
          >
            <MaskCpf value={original.customerCode} />
          </Link>
        ),
      },
      {
        Header: "Origem",
        accessor: "origin",
        Cell: ({ row: { original } }: CellProps) => (
          <IntlEnum name="authorization_origin" value={original.origin} />
        ),
      },
      {
        Header: "CNPJ",
        accessor: "storeCode",
        Cell: ({ row: { original } }: CellProps) =>
          original.storeCode ? (
            <MaskCpf value={original.storeCode} />
          ) : (
            "Não informado"
          ),
      },
      { Header: "Nome", accessor: "name" },
      {
        Header: "Cadastro",
        accessor: "createdAt",
        Cell: ({ value }) => (
          <span title={value}>
            <FormattedDate value={value} />
          </span>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Title>Programas de Beneficiário</Title>
      <GridView<IProgramBeneficiary>
        paginationType="cursor"
        columns={columns}
        hook={useProgramBeneficiaries}
        showRecord={showRecord}
        defaultFilters={id ? [{ id: "id", value: id }] : []}
      />
    </>
  );
}
